import { usePrefixCls } from 'src/hook/useConfig';
import { Breadcrumb } from '@douyinfe/semi-ui';
import { IconUndo } from '@douyinfe/semi-icons';
import useStore from 'src/store';
import { useLocale } from '../../../../locales';
import { useGo } from '../../../../hook/useGo';
import { Fragment } from 'react';
import './header.scss';

const HeaderNav = () => {
  const prefixCls = usePrefixCls('header-breadcrumb');
  const openRouterList = useStore((state) => state.openRouterList);
  const { formatMessage } = useLocale();
  const { go } = useGo();

  const handleClick = (item: any) => {
    // 点击面包屑项目时跳转到对应路径
    if (item.path) {
      go({ path: item.path });
    }
  };

  if (!Array.isArray(openRouterList) || openRouterList.length === 0) {
    return null;
  }

  const isMultiLevel = openRouterList.length > 1;

  return (
    <div className={prefixCls}>
      <Breadcrumb compact={false} separator={'/'}>
        {
          openRouterList.map((item, index) => {
            const isFirst = index === 0;
            const isLast = index === openRouterList.length - 1;

            // 只有当路由层级大于1时，第一个项目才显示"返回上一层"并加上图标
            if (isFirst && isMultiLevel) {
              return (
                <Breadcrumb.Item
                  key={`breadcrumb-${index}`}
                  icon={<IconUndo size='small' />}
                  onClick={() => handleClick(item)}
                >
                  {formatMessage({ id: 'web.common.button.backToParent' })}
                </Breadcrumb.Item>
              );
            }

            return (
              <Breadcrumb.Item
                key={`breadcrumb-${index}`}
                onClick={() => !isLast && handleClick(item)}
                noLink={isLast}
              >
                {formatMessage({
                  id:
                    item.textId ||
                    (typeof item.text === 'string' ? item.text : ''),
                })}
              </Breadcrumb.Item>
            );
          }) as any
        }
      </Breadcrumb>
    </div>
  );
};

export default HeaderNav;
